import { useTranslation } from "react-i18next";
import icons from "../../../Data/icons";
import classes from "./navtabs.module.css";

const NavTabs = ({handleActiveTab,activeTab}) => {
  const { t } = useTranslation();
  const Levels = icons.levels;
  const EmploymentTypes = icons.Employment;
  const WorkShifts = icons.Shifts;
  const Branches = icons.branch
  const Employ = icons.employ
    const Request = icons.request
    const Company = icons.company
  const Device = icons.device
  const CheckCircle = icons.checkCircle
  const Abc =icons.abc
  const Money = icons.money
  const Constracts = icons.constract
  const Tasks = icons.task
  return (
    <div className={classes.NavCol}>
      <div className={classes.NavCard}>
        <ul className={classes.TabsList}>
        <li onClick={()=>handleActiveTab("salary","/salariesSettings/salary")} className={` ${activeTab==="salary" && classes.activeTab }` }>
            <h5>
              {" "}
              <span>
                <Money />
              </span>
              {t("salary")}
            </h5>
     
          </li>
          <li onClick={()=>handleActiveTab("payrolls","/salariesSettings/payrolls")} className={` ${activeTab==="payrolls" && classes.activeTab }` }>
            <h5>
              {" "}
              <span>
                <Money />
              </span>
              {t("Payrolls")}
            </h5>
     
          </li>
     
          <li onClick={()=>handleActiveTab("constracts","/salariesSettings/constracts")} className={` ${activeTab==="constracts" && classes.activeTab }` }>
            <h5>
              {" "}
              <span>
                <Constracts />
              </span>
              {t("constracts")}
            </h5>
     
          </li>
       
        </ul>
      </div>
    </div>
  );
};

export default NavTabs;
